
import { IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonIcon, IonItem, IonLabel } from '@ionic/react'
import { refreshOutline, gameControllerOutline, journalOutline, newspaperOutline } from 'ionicons/icons';
import './Writings.css'

function Writings(){
  return (
    <IonCard className="ion-padding">
      <IonCardHeader>
        <IonCardTitle className="ion-text-center">Writings</IonCardTitle>
        <IonCardSubtitle className="ion-text-center">
          Click an item to learn more
        </IonCardSubtitle>
      </IonCardHeader>

      <IonCard className="ion-padding">
        <IonItem href="https://ojs.stanford.edu/ojs/index.php/intersect/article/view/2046/1422" target = "_blank">
          <IonIcon
            icon={gameControllerOutline}
            slot="start"
            className="ion-icon"
          ></IonIcon>
          <IonLabel className="ion-text-wrap">
            When Moore's Law Killed Chess: How Strategy Games Redefined
            Intelligence in AI
          </IonLabel>
        </IonItem>

        <IonItem href="https://cameronelow.github.io/til/" target="_blank">
          <IonIcon
            icon={journalOutline}
            slot="start"
            className="ion-icon"
          ></IonIcon>
          <IonLabel className="ion-text-wrap">
            AppDev2 Learning Journal
          </IonLabel>
        </IonItem>

        <IonItem
          href="https://medium.com/uchicagotechteam/early-childhood-learning-centers-in-chicago-1bf08846a946"
          target="_blank"
        >
          <IonIcon
            icon={newspaperOutline}
            slot="start"
            className="ion-icon"
          ></IonIcon>
          <IonLabel className="ion-text-wrap">
            Early Childhood Learning Centers in Chicago (Data Journalism)
          </IonLabel>
        </IonItem>

        <IonItem>
          <IonIcon
            icon={refreshOutline}
            slot="start"
            className="ion-icon"
          ></IonIcon>
          <IonLabel>Coming Soon!</IonLabel>
        </IonItem>
      </IonCard>
    </IonCard>
  );
}

export default Writings